import * as React from 'react';
import './App.css';
import zzp from './zzp.jpg';
import {Button, Card, CardActions, CardContent, Divider, Grid, Link, Paper, Typography} from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LanguageIcon from '@mui/icons-material/Language';

function ContactTab({goToRdvTab}) {

    return (
        <>
            <Grid container columnSpacing={10} rowSpacing={2} align="center">
                <Grid item xs={0} sm={4} sx={{display: {xs: 'none', sm: 'block'}}}>
                    <img src={zzp} width="50%" alt="Marine Florins"/>

                </Grid>
                <Grid item xs={12} sm={8}>
                    <Paper elevation={3}>
                        <Grid container>
                            <Grid item xs={12} lg={4}>
                                <Card>
                                    <CardContent align="left">
                                        <Typography variant="h6" align="center">
                                            Marine Florins
                                        </Typography>
                                        <Divider/>
                                        <Typography variant="body2" color="text.secondary"
                                                    style={{lineHeight: "40px", fontSize: '0.8rem'}}>
                                            Marine vous accueille les mardis, mercredis et jeudis.
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary"
                                                    style={{lineHeight: "40px", fontSize: '1rem'}}>
                                            <CallTwoToneIcon/> <Link href="tel:0483017805">0483/01.78.05</Link>
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary"
                                                    style={{lineHeight: "40px", fontSize: '0.9rem'}}>
                                            <LocationOnIcon/> Rue de Mons, 25, Tubize
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary"
                                                    style={{lineHeight: "40px", fontSize: '1rem'}}>
                                            <MailOutlineIcon/> <Link
                                            href="mailto:marineflorins@outlook.com">marineflorins@outlook.com</Link>
                                        </Typography>
                                        <Divider/>
                                        <Typography variant="caption" color="text.primary" align="left">
                                            N° Inami: 6-09108-52-801
                                        </Typography>
                                        <Divider/>

                                    </CardContent>
                                    <CardActions>
                                        <LanguageIcon/> <Button onClick={goToRdvTab} size="small">Prendre rendez-vous en
                                        ligne</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={12} lg={8}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.5023017352046!2d4.201342976384367!3d50.69206267163943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3c9f15543ffff%3A0x771fc34bd9873c33!2sRue%20de%20Mons%2025%2C%201480%20Tubize!5e0!3m2!1sfr!2sbe!4v1756632787321!5m2!1sfr!2sbe"
                                    width="600" height="450" allowFullScreen="" loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

        </>
    );
}

export default ContactTab;
